var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNovelKodansha = function SvgNovelKodansha(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91.55 91.55"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.09 0H0v91.55h91.55V0H5.09zm33.06 5.09H53.4v34.54L45.77 32l-7.62 7.62zm48.31 81.37H5.09V5.09h28v46.82L45.77 39.2l12.72 12.71V5.09h28z"
  })));
};
export { SvgNovelKodansha as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 91.55 91.55'%3e%3cpath d='M5.09 0H0v91.55h91.55V0H5.09zm33.06 5.09H53.4v34.54L45.77 32l-7.62 7.62zm48.31 81.37H5.09V5.09h28v46.82L45.77 39.2l12.72 12.71V5.09h28z'/%3e%3c/svg%3e";